import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Bike, Zap, TrendingUp, MessageCircle } from 'lucide-react';

const TABS = [
  { to: '/', label: 'Accueil', icon: Home, match: (p: string) => p === '/' },
  { to: '/products', label: 'Modèles', icon: Bike, match: (p: string) => p.startsWith('/products') },
  {
    to: '/stations',
    label: 'Recharge',
    icon: Zap,
    match: (p: string) => p.startsWith('/stations') || p.startsWith('/proxy-power') || p.startsWith('/pay-as-you-go'),
  },
  { to: '/invest', label: 'Investir', icon: TrendingUp, match: (p: string) => p.startsWith('/invest') },
  { to: '/contact', label: 'Contact', icon: MessageCircle, match: (p: string) => p.startsWith('/contact') },
];

/** Barre d'onglets bas, style application native — affichée uniquement sur mobile (< md). */
const BottomNav: React.FC = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname.startsWith('/maintenance')) return null;
  // Sur la fiche produit, on laisse la place au CTA d'achat sticky dédié
  if (/^\/products\/[^/]+/.test(pathname)) return null;

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-[90] md:hidden border-t border-neutral-200 bg-white/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      role="navigation"
      aria-label="Navigation mobile"
    >
      <ul className="flex items-stretch justify-around">
        {TABS.map((t) => {
          const active = t.match(pathname);
          const Icon = t.icon;
          return (
            <li key={t.to} className="flex-1">
              <NavLink
                to={t.to}
                aria-current={active ? 'page' : undefined}
                className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 py-2 transition-colors active:bg-neutral-50"
              >
                <Icon
                  size={22}
                  strokeWidth={active ? 2.5 : 2}
                  className={active ? 'text-[#18994E]' : 'text-neutral-400'}
                />
                <span className={`text-[10px] font-semibold leading-none ${active ? 'text-[#18994E]' : 'text-neutral-500'}`}>
                  {t.label}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
